<!--a container for all of the different search components-->
<template>
  <div class="d-flex fade-in-1s">
    <SideBar/>
    <div class="flex-grow-1">

      <nav 
        id="main_nav"
        class="navbar navbar-admin bg-white sticky-top navbar-expand-md py-xs-2 py-0 pl-3"
        style="padding-top: 5px !important; min-height: 45px;"
        role="navigation"
      >
        <a v-if="navbarCollapsed" class="navbar-brand fade-in" href="/">
          <span v-html="'&nbsp;'"></span>
        </a>

 
          <!-- mobile menu icon -->
          <button type="button" class="navbar-toggler height-50" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <!-- /mobile menu icon -->

          <div id="navbar" class="navbar-collapse collapse fade-in">
            <ul
              v-cloak
              id="main_app_nav"
              class="navbar-nav mt-0">
            </ul>

            <div v-cloak class="navbar-nav mr-auto">
              
            </div>

            
            <div class="navbar-nav dropdown navbar-right d-none d-sm-block" style="position: relative;">
              <button v-if="this.$route.name=='accounts'" 
                @click.prevent="addAccount()" 
                class="btn btn-primary btn-sm mr-4" :disabled="false"><span class="glyphicons glyphicons-plus-sign"></span>&nbsp;Add Account</button>

              <a class="mr-2" href="#"
                data-toggle="dropdown"
                ><svg class="align-middle" width="24" height="24" fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g> <g>   <path d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M256,74.667      c67.635,0,122.667,55.031,122.667,122.667S323.635,320,256,320s-122.667-55.031-122.667-122.667S188.365,74.667,256,74.667z      M256,469.333c-69.707,0-131.52-33.755-170.473-85.615c42.676-20.534,103.621-42.385,170.473-42.385      c66.857,0,127.807,21.854,170.474,42.383C387.521,435.577,325.708,469.333,256,469.333z"/> </g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></a>
                  <div id="profileMenu" class="dropdown-menu dropdown-menu-right">
                    <p class="px-4 pt-2 text-secondary font-weight-light">{{userInfo.first_name + " " + userInfo.last_name}}<br>
                      <span class="small font-weight-light text-secondary">{{userInfo.email}}</span>
                    </p>
                    <a href="/admin/#/profile" class="dropdown-item">
                      <span class="glyphicons glyphicons-user mr-1"></span> Profile &amp; Settings
                    </a>

                    <!--<template v-if="privs.AA || privs.AO || privs.AU">
                      <a href="/admin/#/accounts" class="dropdown-item" v-if="privs.AO || privs.AA">
                        <span class="glyphicons glyphicons-settings mr-1"></span> Account Settings
                      </a>
                    </template>-->
                    <div role="separator" class="dropdown-divider"></div>
                    <template v-if="uiConfig && uiConfig.privs && uiConfig.privs.AO">
                      <a href="#" class="dropdown-item" @click.prevent="switchAccounts()">
                        <span class="glyphicons glyphicons-random mr-1"></span>Switch Accounts
                      </a>
                      <div role="separator" class="dropdown-divider"></div>
                    </template>
                    <template v-if="privs.AA">
                      <a href="/reports" class="dropdown-item">
                        <span class="glyphicons glyphicons-table mr-1"></span> Reports
                      </a>
                      <div role="separator" class="dropdown-divider"></div>
                    </template>
                    <a href="#" @click.prevent="showResourceCenter()" target="_blank" class="dropdown-item">
                      <span class="glyphicons glyphicons-question-sign mr-1"></span> Help <small>&amp;</small> Resources
                    </a>
                    <a v-if="privs.AU" href="https://archiver-docs.sageflo.com/collection/14-api" target="_blank" class="dropdown-item">
                      <span class="glyphicons glyphicons-cloud mr-1"></span> API Guide
                    </a>
                    <div role="separator" class="dropdown-divider"></div>
                    <template v-if="(uiConfig) && (uiConfig.settings)">
                      <template v-for="(guide,index) in uiConfig.settings.usage_guides">
                        <a v-bind:href="guide.url" download class="dropdown-item">
                          <span class="glyphicons" v-bind:class="[guide.css_class]"></span> {{guide.caption}}
                        </a>
                        <div v-if="(index+1 == uiConfig.settings.usage_guides.length)" role="separator" class="dropown-divider"></div>
                      </template>
                    </template>
                    <div v-show="privs.EC" role="separator" class="dropdown-divider"></div>
                    <a href="/api/v1/logout" class="dropdown-item"><span class="glyphicons glyphicons-exit mr-1"></span> Log Out </a>
                </div>

            </div>
            <!--<ul class="navbar-nav dropdown mt-2 mt-sm-0 d-none d-sm-block">
              <li class="nav-item">
                <a
                  aria-haspopup="true"
                  aria-expanded="false"
                  class="nav-link dropdown-toggle account-menu-link"
                  data-toggle="dropdown"
                  href="#"
                  id="profileMenu"
                >
                  <span class="glyphicons glyphicons-menu-hamburger hamburger-menu"></span>
                  <span class="plaintext" id="user_name">user name</span>
                </a>

              </li>
            </ul>-->
          </div>
      </nav>


      <!-- Email filters -->
      <PersonaSearchBar v-show="loading==false && (activeView == 'personas' || activeView == 'persona-detail')" ref="searchBar" class="mb-3" />
      <!-- Email filters -->
      <!-- detail content container -->
      <ItemDetail v-show="!loading && activeView=='persona-detail'"/>
      <!-- /detail container -->      
      
      <!-- main list view container -->
      <EmailList  v-show="!loading && resultsSearchType=='email' && activeView=='personas' && viewType=='list'" :isPersonaView="true" ref="listView"/>

      <!-- journey view container -->
      <!-- using v-if because we don't want emails to load in background if we don't want to see them-->
      <JourneyView v-if="viewType=='journey'" :isPersonaView="true" ref="journeyView"/>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import PersonaSearchBar from './persona-search-bar'
import EmailList from './email-list'
import ItemDetail from './item-detail'
import JourneyView from './journey-view'
import SideBar from '../ui/sidebar'

export default {
  components: {PersonaSearchBar,EmailList,ItemDetail,JourneyView,SideBar},
  data: function() {return {

    }
  },
  computed: {
    ...mapState({
      uiConfig: (state)=>state.user.uiConfig,
      privs: (state)=>state.user.privs,
      emails: (state)=>state.search.emails,
      loading: (state)=>state.ui.loading,
      activeView: (state)=>state.ui.activeView,
      detailView: (state)=>state.ui.detailView,
      navbarCollapsed: (state)=>state.ui.navbarCollapsed,
      activeSubAccount: (state)=>state.ui.activeSubAccount,
      viewType: (state)=>state.ui.viewType,      
      selectedEmail: (state)=>state.search.selectedEmail,
      activeEmailSearch: (state)=>state.search.activeEmailSearch,
      emailsearchParams: (state)=>state.search.searchParams,
      filterEmail: (state)=>state.search.filterEmail,
      paginator: (state)=>state.search.paginator,
      resultsSearchType: (state)=>state.search.resultsSearchType,
      resend: (state)=>state.search.resend,      
      userInfo: (state)=>state.user.userInfo,
    }),
  },
  methods: {
    switchAccounts() {
      console.log(this.$refs);
      this.$parent.$refs.SwitchAccounts.showAccounts();
    },
    showResourceCenter(){
      window.pendo.BuildingBlocks.BuildingBlockResourceCenter.getResourceCenter().show()
    },
    toggleSidebar() {
      let collapsed = !this.navbarCollapsed
      this.$store.commit("toggleNavbarCollapse");
      this.$eventBus.$emit("sideBarToggled",{collapsed: collapsed});
      if (collapsed) {
        localStorage.removeItem("navBarExpanded")
      } else {
        localStorage.setItem("navBarExpanded",true)
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch("searchEmails",{}); // clear any search values so other pages don't populate with persona data
    // cleanup event listeners before leaving route
    $('#sidebar *[data-toggle="tooltip"]').tooltip('dispose')
    /*$(document).off('keydown')*/ // commented these out as it was zapping bootstrap listeners
    /*$(document).off('click')*/

    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // access to component instance via `vm`
      vm.$store.dispatch("searchEmails",{}); // clear any search values from main search screen
      vm.$store.commit("setActiveView","personas");
      console.log("before enter persona route")
    })
  },  
}  
</script>
<style scoped>




.small-logo {
  width: 100%;
  max-width: 50px;
  border-radius: .25rem;
  transition:  box-shadow 0.1s;
}

a:hover .small-logo {
  background-color: rgba(63,175,204,.65);
  box-shadow: 0px 0px 4px 3px rgba(63,175,204,.65);
}

.svg-icon.text-light {
  fill: var(--light);
}

.svg-icon.text-muted {
  fill: var(--secondary);
}

</style>